import i18n from "../../constants/i18n";
import ET3Div from "../../core/et3-div";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import Et3Text from "../../core/et3-text";
import getCorePersonalStore from "../../stores/core/core-personal-store";

const Welcome = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;

  const name = `${i18n.get("WELCOME")}: ${
    getCorePersonalStore().user.get().fullName
  }`;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={1500}
      height={800}
      fDirection={"row"}
      color={colors.all.transparent}
      style={{}}
      alignItems="center"
      justifyContent="center"
      onClick={() => {}}
    >
      <Et3Text
        fontFamily={"BOLD"}
        fontSize={100}
        text={`${name}`}
        isSpan={false}
        color={colors.all.blue}
        style={{}}
      />
    </ET3Div>
  );
});
export default Welcome;
